import { render, staticRenderFns } from "./TextAndCounter.vue?vue&type=template&id=240845f7&scoped=true&"
import script from "./TextAndCounter.vue?vue&type=script&lang=js&"
export * from "./TextAndCounter.vue?vue&type=script&lang=js&"
import style0 from "./TextAndCounter.vue?vue&type=style&index=0&id=240845f7&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240845f7",
  null
  
)

export default component.exports